var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.2945,
    height: 139.2945,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 139.2945 139.2945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1784.819,
    y1: -1351.68631,
    x2: -1825.25385,
    y2: -1351.68631,
    gradientTransform: "translate(-61.04004 -1557.24815) rotate(-152.39785) scale(.466 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2070.43583,
    y1: -2470.98207,
    x2: -2110.86962,
    y2: -2470.98207,
    gradientTransform: "translate(-7.97427 -1590.05432) rotate(-148.868) scale(.447 .577)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 139.2945,
    height: 139.2945,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bh2wk8hilc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.76072,30.83632l-30.47067-17.32475c-1.34941-.74-2.96001-.74-4.30942,0l-28.42479,16.10593-20.58947-11.75297-4.09177,7.6612,3.70001,2.08942,16.71534,9.5765v77.00374l-16.23652-9.27179-4.09177,7.6612,22.41771,12.84121c1.34942.78353,3.00354.78353,4.35295,0l28.38126-16.14946,28.33773,16.14945c2.08196,1.20208,4.7442.48879,5.94628-1.59317.37764-.65406.57861-1.39513.58315-2.15037V34.62338c-.00271-1.57039-.85106-3.01758-2.22002-3.78706ZM95.80415,101.7024l-21.8083,12.40592V37.10457l21.8083-12.31886v76.91668ZM126.27482,114.15184l-21.76476-12.40592V24.78571l21.76476,12.36239v77.00374Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.09895,30.47067l-7.92237-2.31577V11.2045l15.23098,5.09731-7.30861,14.16886ZM44.87459,115.96702l-10.60815-.33083v-18.78299l17.0984,7.74826-6.49025,11.36556Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.66076,42.54141l-17.45969-9.12814,8.06602-15.43122,17.4597,9.12814-8.06602,15.43122Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63346,123.49763l-16.17993-9.77238,5.18872-8.59272,16.17993,9.77237-5.18872,8.59273Z",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 69.64725,
    x2: 139.2945,
    y2: 69.64725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 4.35295,
    y1: 69.53997,
    x2: 43.52953,
    y2: 69.53997,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h139.2945v139.2945H0V0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.70591,126.12681c-2.40166.00241-4.35055-1.94258-4.35295-4.34424,0-.00291,0-.0058,0-.00871V34.60598c-.00084-1.56676.84036-3.01309,2.20259-3.78707l30.47067-17.30299c2.09848-1.18282,4.7585-.44053,5.94132,1.65796.36563.64867.5591,1.38015.56199,2.12476v87.16789c.00084,1.56676-.84036,3.0131-2.20259,3.78707l-30.47067,17.30299c-.65571.37161-1.39667.56659-2.15036.56588v.00435ZM13.05886,37.13939v77.15609l21.76476-12.35804V24.78136l-21.76476,12.35803Z",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanSwitcher);
export default __webpack_public_path__ + "static/media/plan_switcher.cbaf3319425005da286610839f5a675a.svg";
export { ForwardRef as ReactComponent };